export enum LinkOpenApproach {
    Modal,
    Self,
    Blank
}
